var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('div', {
        staticClass: "page"
    }, [
        _vm._m(0),
        _vm._m(1),
        _c(_setup.PrivacyDataBox, {
            on: {
                "popup-click": function($event) {
                    _setup.agreed = true;
                }
            },
            model: {
                value: _setup.agreed,
                callback: function callback($$v) {
                    _setup.agreed = $$v;
                },
                expression: "agreed"
            }
        }),
        _c(_setup.CreditFirstRetainPopup, {
            attrs: {
                "step": 4
            },
            on: {
                "close": function($event) {
                    _setup.isShowFirstRetainPopup = false;
                },
                "show-second": _setup.showSecondRetainPopup
            },
            model: {
                value: _setup.isShowFirstRetainPopup,
                callback: function callback($$v) {
                    _setup.isShowFirstRetainPopup = $$v;
                },
                expression: "isShowFirstRetainPopup"
            }
        }),
        _c(_setup.CreditSecondRetainPopup, {
            on: {
                "close": function($event) {
                    _setup.isShowSecondRetainPopup = false;
                },
                "go-home": _setup.goAppHome
            },
            model: {
                value: _setup.isShowSecondRetainPopup,
                callback: function callback($$v) {
                    _setup.isShowSecondRetainPopup = $$v;
                },
                expression: "isShowSecondRetainPopup"
            }
        }),
        _c('div', {
            staticClass: "submit",
            on: {
                "click": function($event) {
                    return _setup.onSubmit();
                }
            }
        }, [
            _vm._v("Siguiente")
        ]),
        !!_setup.liveUrl ? _c('iframe', {
            style: {
                width: '100vw',
                height: '100vh',
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex: 1000000,
                background: '#fff'
            },
            attrs: {
                "src": _setup.liveUrl,
                "allow": "autoplay; camera;"
            }
        }) : _vm._e()
    ], 1);
};
var staticRenderFns = [
    function() {
        var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
        return _c('div', {
            staticClass: "progress"
        }, [
            _c('img', {
                attrs: {
                    "src": require("@/assets/img/credit/step4.png")
                }
            })
        ]);
    },
    function() {
        var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
        return _c('div', {
            staticClass: "card"
        }, [
            _c('div', {
                staticClass: "card-content"
            }),
            _c('div', {
                staticClass: "card-title"
            }, [
                _vm._v("Notas para realizar la identificación:")
            ]),
            _c('div', {
                staticClass: "card-item"
            }, [
                _vm._v("1、Mantén buena iluminación")
            ]),
            _c('div', {
                staticClass: "card-item"
            }, [
                _vm._v("2、Mantén el teléfono en vertical")
            ]),
            _c('div', {
                staticClass: "card-item"
            }, [
                _vm._v("3、Mantén el rostro despejado")
            ])
        ]);
    }
];
export { render, staticRenderFns };
